import { Logger } from "../logger/logger";
import { InvalidParameterError } from "../core/exception/invalid-parameter-error";
import { ServiceProvider } from "../core/provider/service-provider";
import { MessageHelper } from "../helper/message-helper";
import { DialogResultVm } from "../checkresultdialog/dialogresultvm";
import { ObjectHelper } from "../helper/object-helper";
import { UrlHelper } from "../core/html/url-helper";
import { CheckResultData } from "../checkresultdialog/checkresultdata";
import { IAjaxOptions } from "../core/provider/provider-interfaces";

export type ILookupOptions = IAjaxOptions;

export class Lookup<T> {
	private orgOptions: ILookupOptions;

	constructor(public options: ILookupOptions) {
		if (options == null) {
			throw new InvalidParameterError("options", InvalidParameterError.nullText);
		}

		if (options.cache == null) {
			options.cache = true;
		}

		if (options.method == null) {
			options.method = "GET";
		}

		this.orgOptions = this.options ? ObjectHelper.getDeepMerged(this.options, null) : {};
	}

	public items: KnockoutObservableArray<T> = ko.observableArray([]);
	protected loaded: boolean = false;

	public loadAsync: () => Promise<boolean> = () => {
		return this.loadItemsAsync();
	}

	public reloadAsync: () => Promise<boolean> = () => {
		return this.loadItemsAsync(true);
	}

	protected getLookupCacheParam = () => {
		return this.orgOptions.params ? "?" + JSON.stringify(this.orgOptions.params) : "";
	}

	protected loadItemsAsync = async (force?: boolean): Promise<boolean> => {
		if (!this.options.url) {
			Logger.error("No URL specified for lookup");
			throw Error("Es wurde keine URL für den Lookup angegeben.");
		}

		this.options.params = this.options.params || {};
		if (this.options.cache && this.options.method === "GET") {
			this.options.params.v = UrlHelper.getCacheId();
		}

		let result: T[] | CheckResultData = await ServiceProvider.ajax.jsonAsync(this.options).catch((err) => {
			Logger.error(`Could not load items from url: ${this.options.url}`, this.options, err);
			MessageHelper.uiError("Ein Lookup konnte nicht durchgeführt werden");
			return null;
		});

		if (!result) {
			return false;
		}

		let crData = (result as CheckResultData<T[]>);

		switch (crData.success) {
			case false:
				DialogResultVm.showDialog(crData);
				return false;

			case true:
				this.items(crData.resultData);
				this.loaded = true;
				return true;

			default:
				this.items(result as T[]);
				this.loaded = true;
				return true;
		}
	}
}